import ApiClient from '../../../../../resources/js/apiClient'
import moment from 'moment/moment'

class ApiService {
  constructor (config) {
    this.http = new ApiClient(config)
  }

  /**
   * @param {String} domain
   * @returns {Promise<AxiosResponse<T>>}
   */
  getFormsSosAvailability (domain) {
    return this.http.get('forms/sos-availability', {
      params: {
        domain
      }
    })
  }

  /**
   * @param {String} domain
   * @param {Array} typesAccess
   * @returns {Promise<AxiosResponse<T>>}
   */
  postFormsAccess (domain, typesAccess) {
    return this.http.post('forms/access', {
      domain,
      typesAccess
    })
  }

  /**
   * @param {String} domain
   * @param {String} name
   * @param {String} phone
   * @returns {Promise<AxiosResponse<T>>}
   */
  postFormsCallOrder (domain, name, phone) {
    return this.http.post('forms/call-order', {
      domain,
      name,
      phone
    })
  }

  /**
   * @param {String} domain
   * @param {String} reason
   * @param {String} comment
   * @param {Array} files
   * @returns {Promise<AxiosResponse<T>>}
   */
  postFormsSosAppeal (domain, reason, comment, files) {
    const data = new FormData()
    data.append('domain', domain)
    data.append('reason', reason)
    if (comment) {
      data.append('comment', comment)
    }
    for (const file of files) {
      data.append('files[]', file.file)
    }

    return this.http.post(
      'forms/sos-appeal',
      data,
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    )
  }

  /**
   * @returns {Promise<AxiosResponse<T>>}
   */
  getFormsSosListReasons () {
    return this.http.get('forms/sos-list-reasons')
  }

  /**
   * @returns {Promise<AxiosResponse<T>>}
   */
  getFormsTypesAccess () {
    return this.http.get('forms/types-access')
  }

  /**
   * @param {String} domain
   * @param {String} text
   * @param {Array} files
   * @returns {Promise<AxiosResponse<T>>}
   */
  postMailOrder (domain, text, files) {
    const data = new FormData()
    data.append('domain', domain)
    data.append('text', text)
    for (const file of files) {
      data.append('files[]', file.file)
    }

    return this.http.post(
      'forms/mail-order',
      data,
      {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
    )
  }

  /**
   * @param {String} domain
   * @param {String} name
   * @param {String} comment
   * @param {String} email
   * @param {String} type
   * @returns {Promise<AxiosResponse<T>>}
   */
  postFormsQualityService (domain, name, comment, email, type) {
    return this.http.post('forms/quality-service', {
      domain,
      name,
      comment,
      email,
      type: type || undefined
    })
  }

  /**
   * @param {String} domain
   * @returns {Promise<AxiosResponse<T>>}
   */
  getFormsInterview (domain) {
    return this.http.get('forms/interview', {
      params: {
        domain
      }
    })
  }

  /**
   * @param {String} domain
   * @returns {Promise<AxiosResponse<T>>}
   */
  getFormsLoyaltyProgramMap (domain) {
    return this.http.get('forms/loyalty-program-map', {
      params: {
        domain
      }
    })
  }

  /**
   * @param {String} domain
   * @param {String} typeEvent
   * @param {Object} data
   * @returns {Promise<AxiosResponse<T>>}
   */
  postFormsPackageAccepted (domain, typeEvent, data) {
    return this.http.post('forms/package-accepted', {
      domain,
      type_event: typeEvent,
      data
    })
  }

  /**
   * @param {String} domain
   * @param {String} period
   * @returns {Promise<AxiosResponse<T>>}
   */
  postFormsDocumentsOrder (domain, period) {
    return this.http.post('forms/documents-order', {
      domain,
      period
    })
  }

  /**
   * @param {String} domain
   * @param {String} orderType
   * @param {String} text
   * @returns {Promise<AxiosResponse<T>>}
   */
  postFormsLoyaltyProgram (domain, orderType, text) {
    return this.http.post('forms/loyalty-program', {
      domain,
      order_type: orderType,
      text
    })
  }

  /**
   * @param {String} domain
   * @param {String} phone
   * @param {String} service
   * @returns {Promise<AxiosResponse<any>>}
   */
  postFormsServiceOrder (domain, phone, service) {
    return this.http.post('forms/service-order', {
      domain,
      phone,
      service
    })
  }

  /**
   * @returns {Promise<AxiosResponse<T>>}
   */
  getClientInfo () {
    return this.http.get('client/info')
  }

  /**
   * @returns {Promise<AxiosResponse<T>>}
   */
  getClientDomains () {
    return this.http.get('client/domains')
  }

  /**
   * @param {String} domain
   * @returns {Promise<AxiosResponse<T>>}
   */
  getClientProjects (domain) {
    return this.http.get('client/projects', {
      params: {
        domain
      }
    })
  }

  /**
   * @returns {Promise<AxiosResponse<any>>}
   */
  getClientUnpaidDomains () {
    return this.http.get('client/unpaid-domains')
  }

  /**
   * @returns {Promise<AxiosResponse<any>>}
   */
  getClientAgreements () {
    return this.http.get('client/agreements')
  }

  /**
   * @returns {Promise<AxiosResponse<T>>}
   *
   * @deprecated
   */
  getProjects () {
    return this.http.get('projects')
  }

  /**
   * @param {String} domain
   * @param {Number} connected
   * @returns {Promise<AxiosResponse<T>>}
   */
  getProjectServices (domain, connected) {
    return this.http.get('project/services', {
      params: {
        domain,
        connected
      }
    })
  }

  /**
   * @param {Number} idParent
   * @param {Number} withPriority
   * @returns {Promise<AxiosResponse<T>>}
   */
  getProjectPriorityPositions (idParent, withPriority) {
    return this.http.get('project/priority-positions', {
      params: {
        id_parent: idParent,
        with_priority: withPriority || 0
      }
    })
  }

  /**
   * @returns {Promise<AxiosResponse<T>>}
   */
  getUpdatesCurrent () {
    return this.http.get('updates/current')
  }

  /**
   * @param {Number} idParent
   * @param {String} sengine
   * @param from
   * @param to
   * @param {String} type
   * @returns {Promise<AxiosResponse<T>>}
   */
  getPositions (idParent, sengine, from, to, type) {
    return this.http.get('positions', {
      params: {
        id_parent: idParent,
        sengine,
        from: moment(from).format('YYYY-MM-DD'),
        to: moment(to).format('YYYY-MM-DD'),
        type
      }
    })
  }

  /**
   * @param {Number} idParent
   * @param {String} sengine
   * @param from
   * @param to
   * @param {String} type
   * @returns {Promise<AxiosResponse<T>>}
   */
  getPositionsExport (idParent, sengine, from, to, type) {
    return this.http.get('positions/export', {
      responseType: 'blob',
      params: {
        id_parent: idParent,
        sengine,
        from: moment(from).format('YYYY-MM-DD'),
        to: moment(to).format('YYYY-MM-DD'),
        type
      }
    })
  }

  /**
   * @param {Number} idParent
   * @param {String} sengine
   * @param from
   * @param to
   * @returns {Promise<AxiosResponse<T>>}
   */
  getMoney (idParent, sengine, from, to) {
    return this.http.get('money', {
      params: {
        id_parent: idParent,
        sengine,
        from: moment(from).format('YYYY-MM-DD'),
        to: moment(to).format('YYYY-MM-DD')
      }
    })
  }

  /**
   * @param {Number} idParent
   * @param {String} sengine
   * @param from
   * @param to
   * @returns {Promise<AxiosResponse<T>>}
   */
  getMoneyExport (idParent, sengine, from, to) {
    return this.http.get('money/export', {
      responseType: 'blob',
      params: {
        id_parent: idParent,
        sengine,
        from: moment(from).format('YYYY-MM-DD'),
        to: moment(to).format('YYYY-MM-DD')
      }
    })
  }

  /**
   * @param {Number} idParent
   * @returns {Promise<AxiosResponse<any>>}
   */
  getType (idParent) {
    return this.http.get('type', {
      params: {
        id_parent: idParent
      }
    })
  }

  /**
   * @param {String} domain
   * @returns {Promise<AxiosResponse<any>>}
   */
  getTrafficCommon (domain) {
    return this.http.get('traffic/common', {
      params: {
        domain
      }
    })
  }

  /**
   * @param {String} domain
   * @param from
   * @param to
   * @param {String} type
   * @param {String} metrics
   * @returns {Promise<AxiosResponse<any>>}
   */
  getTrafficMetrics (domain, from, to, type, metrics) {
    return this.http.get('traffic/metrics', {
      params: {
        domain,
        from: moment(from).startOf('months').format('YYYY-MM-DD'),
        to: moment(to).endOf('months').format('YYYY-MM-DD'),
        type,
        metrics
      }
    })
  }

  /**
   * @param {String} domain
   * @param {String} type
   * @param from
   * @param to
   * @returns {Promise<AxiosResponse<any>>}
   */
  getDocuments (domain, type, from, to) {
    return this.http.get('documents', {
      params: {
        domain,
        type,
        from: moment(from).format('YYYY-MM-DD'),
        to: moment(to).format('YYYY-MM-DD')
      }
    })
  }

  /**
   * @param {String} domain
   * @param {Number} year
   * @param {Number} month
   * @returns {Promise<AxiosResponse<any>>}
   */
  getReport (domain, year, month) {
    return this.http.get('report', {
      params: {
        domain,
        year,
        month
      }
    })
  }

  /**
   * @param {String} domain
   * @returns {Promise<AxiosResponse<any>>}
   */
  getExistenceNewReports (domain) {
    return this.http.get('existence-new-reports', {
      params: {
        domain
      }
    })
  }

  /**
   * @param {String} domain
   * @returns {Promise<AxiosResponse<any>>}
   */
  getGoodNews (domain) {
    return this.http.get('good-news', {
      params: {
        domain
      }
    })
  }

  /**
   * @param {String} domain
   * @returns {Promise<AxiosResponse<any>>}
   */
  getGoodNewsRead (domain) {
    return this.http.get('good-news/read', {
      params: {
        domain
      }
    })
  }

  /**
   * @param {String} domain
   * @param {Array} sections
   * @returns {Promise<AxiosResponse<any>>}
   */
  updateGoodNewsRead (domain, sections) {
    return this.http.put('good-news/read', { domain, sections })
  }
}

export default new ApiService({
  responseType: 'json',
  baseURL: '/api/seo/'
})
